export function CNSGfg() {
    // Array of objects containing link data
    const links = [
      { label: "1. (Part-1) Intro To CNS ( Basics)", url: "https://www.geeksforgeeks.org/javascript/?ref=lbp" },
      { label: "2. (Part-2) Comments", url: "https://www.geeksforgeeks.org/javascript-comments/?ref=lbp" },
      { label: "3. (Part-3) DataTypes", url: "https://www.geeksforgeeks.org/variables-datatypes-javascript/?ref=lbp" },
      { label: "4. (Part-4) Let", url: "https://www.geeksforgeeks.org/javascript-let/?ref=lbp" },
      { label: "5. (Part-5) Var", url: "https://www.geeksforgeeks.org/javascript-var/?ref=lbp" },
      { label: "6. (Part-6) Const", url: "https://www.geeksforgeeks.org/javascript-const/?ref=lbp" },
      { label: "7. (Part-7) Operators", url: "https://www.geeksforgeeks.org/javascript-operators/?ref=lbp" },
      { label: "8. (Part-8) Statements", url: "https://www.geeksforgeeks.org/javascript-statements/?ref=lbp" },
      { label: "9. (Part-9) if-else", url: "https://www.geeksforgeeks.org/javascript-if-else/?ref=lbp" },
      { label: "10. (Part-10) switch", url: "https://www.geeksforgeeks.org/switch-case-in-javascript/?ref=lbp" },
      { label: "11. (Part-11) Break", url: "https://www.geeksforgeeks.org/javascript-break-statement/?ref=lbp" },
      { label: "12. (Part-12) Continue", url: "https://www.geeksforgeeks.org/javascript-continue-statement/?ref=lbp" },
      { label: "13. (Part-13) Return", url: "https://www.geeksforgeeks.org/javascript-return-statement/?ref=lbp" },
      { label: "1.1 . (Part-1.1) Loops, for, while, do-while, forEach etc.", url: "https://www.geeksforgeeks.org/loops-in-javascript/?ref=lbp" },
      { label: "1.2 . (Part-1.2) Objects, Structure Destructure", url: "https://www.geeksforgeeks.org/objects-in-javascript/?ref=lbp" },
      { label: "1.3 . (Part-1.3) Functions, Arrow Functions", url: "https://www.geeksforgeeks.org/functions-in-javascript/?ref=lbp" },
      { label: "1.4 . (Part-1.4) Arrays", url: "https://www.geeksforgeeks.org/javascript-arrays/?ref=lbp" },
      { label: "1.5 . (Part-1.5) Strings", url: "https://www.geeksforgeeks.org/javascript-strings/?ref=lbp" },
    ];
  
    return (
      <>
        <h1 className="html_gfg_heading">
          These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 8</strong> recommended Geeks for Geeks links that you can refer with important Topics
        </h1>
        <h4 className="des_co_html">
          1. Dive Into The<strong> Main </strong>Concepts <br />
          2. Enough Concepts to learn & Understand <br />
          3. Only important Concepts to learn through every topic
        </h4>
  
        <div className="container_html_gfg_links">
          {links.map((link, index) => (
            <div key={index}>
              <p className="vid">
                {link.label}
                <button
                  style={{
                    marginLeft: '200px',
                    padding: '7px',
                    background: 'black',
                    color: 'white',
                    borderRadius: '8px',
                  }}
                  onClick={() => window.open(link.url, "_blank")}
                >
                  Click Me
                </button>
              </p>
            </div>
          ))}
        </div>
      </>
    );
  }
export default CNSGfg;  